import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

/**
 * Guard pour protéger les routes nécessitant une authentification.
 * Redirige vers la page de login si l'utilisateur n'est pas authentifié.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // isAuthenticated() vérifie maintenant aussi la validité du token
  if (auth.isAuthenticated()) {
    return true;
  }

  // Rediriger vers la page de login avec l'URL de redirection
  router.navigate(['/auth'], { queryParams: { redirectTo: state.url } });
  return false;
};
